// export default ProductMap = {
exports.ProductMap = {
  13: {
    '2kWh': [{
      name: 'Get Set Kit (2kWh)',
      pid: '7173137334481',
      varId: '41385759604945',
      adaptBatCap: 2,
      limit: 2,
      off_price: '75998',
      old_price: '75998',
      // save_money: '600',
      imgSrc: '/img/mm100/preview/setkit-2kw.jpg',
      delivery_date: 'Early Augest 2022',
      accessories: ['1x Power Hub', '1x 2kWh LFP Battery', '1x Cable Pack'],
      detailImgList: ['power-2kw.jpg', 'wire.jpg'],
      desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.'
    }, {
      name: 'Prepared Kit (2kWh)',
      pid: '7173137334481',
      varId: '41385759637713',
      adaptBatCap: 2,
      limit: 2,
      off_price: '84998',
      old_price: '84998',
      // save_money: '700',
      imgSrc: '/img/mm100/preview/prekit-2kw.jpg',
      delivery_date: 'Early Augest 2022',
      accessories: ['1x Power Hub', '1x 2kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Battery Mounting Strap'],
      detailImgList: ['bundle-2kw-dp.jpg', 'wire.jpg'],
      desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.'
    }, {
      name: 'Independence Kit (2kWh)',
      pid: '7173137334481',
      varId: '41385759670481',
      adaptBatCap: 2,
      limit: 2,
      off_price: '88998',
      old_price: '88998',
      // save_money: '900',
      imgSrc: '/img/mm100/preview/indkit-2kw-us.jpg',
      delivery_date: 'Early Augest 2022',
      accessories: ['1x Power Hub', '1x 2kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console', '1x Battery Mounting Strap'],
      detailImgList: ['bundle-2kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.'
    }],
    '4kWh': [{
      name: 'Get Set Kit (4kWh)',
      pid: '7173143855313',
      varId: '41385766813905',
      adaptBatCap: 2,
      limit: 1,
      off_price: '111997',
      old_price: '111997',
      // save_money: '900',
      imgSrc: '/img/mm100/preview/setkit-4kw.jpg',
      delivery_date: 'Early Augest 2022',
      accessories: ['1x Power Hub', '2x 2kWh LFP Battery', '1x Cable Pack'],
      detailImgList: ['power-4kw.jpg', 'wire.jpg'],
      desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.'
    }, {
      name: 'Prepared Kit (4kWh)',
      pid: '7173143855313',
      varId: '41385766846673',
      adaptBatCap: 2,
      limit: 1,
      off_price: '120997',
      old_price: '120997',
      // save_money: '1000',
      imgSrc: '/img/mm100/preview/prekit-4kw.jpg',
      delivery_date: 'Early Augest 2022',
      accessories: ['1x Power Hub', '2x 2kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '2x Battery Mounting Strap'],
      detailImgList: ['bundle-4kw-dp.jpg', 'wire.jpg'],
      desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.'
    }, {
      name: 'Independence Kit (4kWh)',
      pid: '7173143855313',
      varId: '41385766879441',
      adaptBatCap: 2,
      limit: 1,
      off_price: '124997',
      old_price: '124997',
      // save_money: '1200',
      imgSrc: '/img/mm100/preview/indkit-4kw-us.jpg',
      delivery_date: 'Early Augest 2022',
      accessories: ['1x Power Hub', '2x 2kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console', '2x Battery Mounting Strap'],
      detailImgList: ['bundle-4kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.'
    }],
    '5kWh': [{
      name: 'Get Set Kit (5kWh)',
      pid: '7173147721937',
      varId: '41385771008209',
      adaptBatCap: 5,
      limit: 2,
      off_price: '104998',
      old_price: '104998',
      // save_money: '1100',
      imgSrc: '/img/mm100/preview/setkit-5kw.jpg',
      delivery_date: 'Early Augest 2022',
      accessories: ['1x Power Hub', '1x 5kWh LFP Battery', '1x Cable Pack'],
      detailImgList: ['power-5kw.jpg', 'wire.jpg'],
      desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.'
    }, {
      name: 'Prepared Kit (5kWh)',
      pid: '7173147721937',
      varId: '41385771040977',
      adaptBatCap: 5,
      limit: 2,
      off_price: '113998',
      old_price: '113998',
      // save_money: '1200',
      imgSrc: '/img/mm100/preview/prekit-5kw.jpg',
      delivery_date: 'Early Augest 2022',
      accessories: ['1x Power Hub', '1x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Battery Mounting Strap'],
      detailImgList: ['bundle-5kw-dp.jpg', 'wire.jpg'],
      desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.'
    }, {
      name: 'Independence Kit (5kWh)',
      pid: '7173147721937',
      varId: '41385771073745',
      adaptBatCap: 5,
      limit: 2,
      off_price: '117998',
      old_price: '117998',
      // save_money: '1400',
      imgSrc: '/img/mm100/preview/indkit-5kw-us.jpg',
      delivery_date: 'Early Augest 2022',
      accessories: ['1x Power Hub', '1x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console', '1x Battery Mounting Strap'],
      detailImgList: ['bundle-5kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.'
    }],
    '10kWh': [{
      name: 'Get Set Kit (10kWh)',
      pid: '7173148246225',
      varId: '41385771598033',
      adaptBatCap: 5,
      limit: 1,
      off_price: '169997',
      old_price: '169997',
      // save_money: '1500',
      imgSrc: '/img/mm100/preview/setkit-10kw.jpg',
      delivery_date: 'Early Augest 2022',
      accessories: ['1x Power Hub', '2x 5kWh LFP Battery', '1x Cable Pack'],
      detailImgList: ['power-10kw.jpg', 'wire.jpg'],
      desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.'
    }, {
      name: 'Prepared Kit (10kWh)',
      pid: '7173148246225',
      varId: '41385771630801',
      adaptBatCap: 5,
      limit: 1,
      off_price: '178997',
      old_price: '178997',
      // save_money: '1700',
      imgSrc: '/img/mm100/preview/prekit-10kw.jpg',
      delivery_date: 'Early Augest 2022',
      accessories: ['1x Power Hub', '2x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '2x Battery Mounting Strap'],
      detailImgList: ['bundle-10kw-dp.jpg', 'wire.jpg'],
      desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.'
    }, {
      name: 'Independence Kit (10kWh)',
      pid: '7173148246225',
      varId: '41385771663569',
      adaptBatCap: 5,
      limit: 1,
      off_price: '182997',
      old_price: '182997',
      // save_money: '1900',
      imgSrc: '/img/mm100/preview/indkit-10kw-us.jpg',
      delivery_date: 'Early Augest 2022',
      accessories: ['1x Power Hub', '2x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console', '2x Battery Mounting Strap'],
      detailImgList: ['bundle-10kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.'
    }],
    '15kWh': [{
      name: 'Get Set Kit (15kWh)',
      pid: '7173148573905',
      varId: '41385772056785',
      off_price: '234996',
      old_price: '234996',
      // save_money: '1900',
      imgSrc: '/img/mm100/preview/setkit-15kw.jpg',
      delivery_date: 'Early Augest 2022',
      accessories: ['1x Power Hub', '3x 5kWh LFP Battery', '1x Cable Pack'],
      detailImgList: ['power-15kw.jpg', 'wire.jpg'],
      desc: 'The Get Set Kit allows you to quickly build a basic electrical system for your van/off-grid home using an LFP battery and Power Hub.'
    }, {
      name: 'Prepared Kit (15kWh)',
      pid: '7173148573905',
      varId: '41385772089553',
      off_price: '243996',
      old_price: '243996',
      // save_money: '2200',
      imgSrc: '/img/mm100/preview/prekit-15kw.jpg',
      delivery_date: 'Early Augest 2022',
      accessories: ['1x Power Hub', '3x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '3x Battery Mounting Strap'],
      detailImgList: ['bundle-15kw-dp.jpg', 'wire.jpg'],
      desc: 'The Prepared Kit gives you more control over your power usage, offering comfort and convenience while traveling or living off-grid.'
    }, {
      name: 'Independence Kit (15kWh)',
      pid: '7173148573905',
      varId: '41385772122321',
      off_price: '247996',
      old_price: '247996',
      // save_money: '2400',
      imgSrc: '/img/mm100/preview/indkit-15kw-us.jpg',
      delivery_date: 'Early Augest 2022',
      accessories: ['1x Power Hub', '3x 5kWh LFP Battery', '1x Cable Pack', '1x AC / DC Smart Distribution Panel', '1x Power Kit Console', '3x Battery Mounting Strap'],
      detailImgList: ['bundle-15kw-all_us.jpg', 'wire.jpg'],
      desc: 'The Independence Kit provides a complete off-grid power solution. With the EcoFlow AC/DC Smart Distribution Panel and Power Kit Console, you can monitor, control, and customize your power from the wall or mobile app.'
    }]
  }
};
exports.solarPanelMap = {
  13: [{
    name: '2*100W Rigid Solar Panel+2*Rigid solar mounting feet',
    pid: '7146943774929',
    varId: '41319240597713',
    old_price: '2999',
    off_price: '2999',
    // save_money: '100',
    limit: 99,
    imgSrc: '/img/mm100/preview/rigid-100w.jpg'
  }, {
    name: '2*400W Rigid Solar Panel+4*Rigid solar mounting feet',
    pid: '7146943840465',
    varId: '41319240827089',
    old_price: '10999',
    off_price: '10999',
    // save_money: '100',
    tips: '*This item excludes free shipping.',
    limit: 99,
    imgSrc: '/img/mm100/preview/rigid-400w.jpg'
  }, {
    name: '1*400W Portable Solar Panel',
    pid: '7027755253969',
    varId: '41029911085265 ',
    old_price: '19999',
    off_price: '19999',
    // save_money: '0',
    limit: 99,
    imgSrc: '/img/mm100/preview/flexibel-400w.jpg'
  }]
};
exports.BatteryMap = {
  13: [{
    name: '2kWh LFP Battery',
    pid: '7173150965969',
    varId: '41385774416081',
    off_price: '35999',
    old_price: '35999',
    // save_money: '100',
    capacity: 2,
    imgSrc: '/img/mm100/preview/battery-2kw.jpg'
  }, {
    name: '5kWh LFP Battery',
    pid: '7173150965969',
    varId: '41385774448849',
    off_price: '64999',
    old_price: '64999',
    // save_money: '200',
    capacity: 5,
    imgSrc: '/img/mm100/preview/battery-5kw.jpg'
  }]
};
exports.InstallationMap = {
  13: {
    pid: '7598187413702',
    varId: '42210557034694',
    off_price: '0',
    old_price: '0',
    save_money: '0'
  }
};
exports.ConsoleMap = {
  13: []
};
exports.ShopifyUrl = 'https://za.ecoflow.com/';